function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["selectedIds", "filterBy"],
  _excluded2 = ["normalizedTree", "orderedIds", "highlightedId", "getTreeNodeProps"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCallback, useMemo, useRef } from 'react';
import useTree from './useTree';
var useDropdownTree = function useDropdownTree(_ref) {
  var selectedIds = _ref.selectedIds,
    _ref$filterBy = _ref.filterBy,
    filterBy = _ref$filterBy === void 0 ? function (item, val) {
      return item.startsWith(val);
    } : _ref$filterBy,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var _useTree = useTree(_objectSpread({
      selectedIds: selectedIds
    }, props)),
    normalizedTree = _useTree.normalizedTree,
    orderedIds = _useTree.orderedIds,
    highlightedId = _useTree.highlightedId,
    rawGetTreeNodeProps = _useTree.getTreeNodeProps,
    useTreeReturnValue = _objectWithoutProperties(_useTree, _excluded2);
  var items = orderedIds.map(function (x) {
    return normalizedTree[x];
  });
  var selectedItems = useMemo(function () {
    if (selectedIds === undefined) return undefined;
    return Object.entries(selectedIds).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        isSelected = _ref3[1];
      return isSelected === true && normalizedTree[id];
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        id = _ref5[0];
      return normalizedTree[id];
    });
  }, [normalizedTree, selectedIds]);
  var selectedItem = useMemo(function () {
    if (selectedItems === undefined) return undefined;
    if (selectedItems !== null && selectedItems !== void 0 && selectedItems[0]) return selectedItems[0];
    return null;
  }, [selectedItems]);
  var highlightedIndex = highlightedId ? orderedIds.indexOf(highlightedId) : -1;
  var getFilteredItems = useCallback(function (_ref6) {
    var inputValue = _ref6.inputValue,
      allItems = _ref6.allItems,
      itemToString = _ref6.itemToString;
    var allItemsMap = new Map(allItems.map(function (item) {
      return [item.id, item];
    }));
    var matchingItems = !inputValue || inputValue.toLowerCase().trim() === '' ? allItems : allItems.filter(function (item) {
      return filterBy(itemToString(item).toLowerCase(), inputValue.toLowerCase());
    });
    var filteredItems = new Map();
    matchingItems.forEach(function (matchingItem) {
      normalizedTree[matchingItem.id].path.forEach(function (parentId) {
        var parentItem = allItemsMap.get(parentId);
        if (parentItem) {
          filteredItems.set(parentId, parentItem);
        }
      });
      filteredItems.set(matchingItem.id, matchingItem);
    });
    return Array.from(filteredItems.values());
  }, [filterBy, normalizedTree]);
  var getTreeNodeProps = useCallback(function (node) {
    var treeNodeProps = rawGetTreeNodeProps(node);
    var onMouseUp = function onMouseUp() {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    };
    return _objectSpread({
      onMouseUp: onMouseUp
    }, treeNodeProps);
  }, [rawGetTreeNodeProps]);
  return _objectSpread(_objectSpread({
    normalizedTree: normalizedTree,
    orderedIds: orderedIds,
    getFilteredItems: getFilteredItems,
    getTreeNodeProps: getTreeNodeProps
  }, useTreeReturnValue), {}, {
    items: items,
    inputRef: inputRef,
    // for refocusing input
    selectedItems: selectedItems,
    // multi select case
    selectedItem: selectedItem,
    // single select case
    highlightedIndex: highlightedIndex
  });
};
export default useDropdownTree;
//# sourceMappingURL=useDropdownTree.js.map